const initialState = {
  nav: {
    open: false
  },
  theme: 'DEFAULT'
};


export default (state = initialState, action) => {
  switch (action.type) {

    case 'SET_NAVBAR_STATE':
      return {
        ...state,
        nav: {
          ...state.nav,
          open: !state.nav.open
        }
      };

    case 'SET_THEME':
      return {
        ...state,
        theme: action.payload
      };

    default:
      return state;

  }
};



// WEBPACK FOOTER //
// ./src/reducers/layoutReducer.js